import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { AnpReportData, AnpReportResponse } from "../types/anpReports.type";

type UseAnpReportParams = {
  id?: string;
};

type UseAnpReportType = (params: UseAnpReportParams) => UseQueryResult<AnpReportData, unknown>;

const useAnpReport: UseAnpReportType = ({ id }) => {
  const privateAxios = usePrivateAxios();

  return useQuery<AnpReportResponse, unknown, AnpReportData>({
    enabled: !!id,
    queryKey: ['anpReport', id],
    queryFn: () => privateAxios.get(`/anp/reports/${id}`),
    select: (response) => response?.data?.data,
  });
};

export default useAnpReport;
